/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { AgreementsControllerFindAllQueryResponse, AgreementsControllerFindAll401 } from "../../models/agreementsController/AgreementsControllerFindAll";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { agreementsControllerFindAll } from "../../clients/agreementsService/agreementsControllerFindAll";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const agreementsControllerFindAllQueryKey = () => [{
  url: '/api/v1/agreements'
}] as const;
export type AgreementsControllerFindAllQueryKey = ReturnType<typeof agreementsControllerFindAllQueryKey>;
export function agreementsControllerFindAllQueryOptions(config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = agreementsControllerFindAllQueryKey();
  return queryOptions<AgreementsControllerFindAllQueryResponse, ResponseErrorConfig<AgreementsControllerFindAll401>, AgreementsControllerFindAllQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return agreementsControllerFindAll(config);
    }
  });
}

/**
 * @summary List all active agreements
 * {@link /api/v1/agreements}
 */
export function useAgreementsControllerFindAll<TData = AgreementsControllerFindAllQueryResponse, TQueryData = AgreementsControllerFindAllQueryResponse, TQueryKey extends QueryKey = AgreementsControllerFindAllQueryKey>(options: {
  query?: Partial<QueryObserverOptions<AgreementsControllerFindAllQueryResponse, ResponseErrorConfig<AgreementsControllerFindAll401>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? agreementsControllerFindAllQueryKey();
  const query = useQuery({
    ...agreementsControllerFindAllQueryOptions(config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<AgreementsControllerFindAll401>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}